import { ADDRESSES_ACTIONS, initialAddressesState } from './addresses.types'

/**
 * @param {import('./addresses.types').AddressesSlice} state
 * @param {Object} action
 */
export function addressesReducer(state = initialAddressesState, { type, payload }) {
  switch (type) {
    case ADDRESSES_ACTIONS.SET_ADDRESSES:
      return { ...state, data: payload }

    case ADDRESSES_ACTIONS.UPDATE_ADDRESS:
      return {
        ...state,
        data: state.data.map(address => (address.id === payload.id ? { ...address, ...payload } : address))
      }

    case ADDRESSES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case ADDRESSES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case ADDRESSES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
